import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PersonaLiveKitChat from '../components/persona/PersonaLiveKitChat';
import { apiService } from '../services/api';
import './PersonaChatPage.css';

const PersonaChatPage = () => {
  const { personaId } = useParams();
  const [persona, setPersona] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadPersona = async () => {
      try {
        setLoading(true);
        const personaData = await apiService.getPersona(personaId);
        setPersona(personaData);
        setError(null);
      } catch (error) {
        console.error('Error loading persona:', error);
        setError('Persona not found or failed to load');
      } finally {
        setLoading(false);
      }
    };

    if (personaId) {
      loadPersona();
    }
  }, [personaId]);

  if (loading) {
    return (
      <div className="persona-chat-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading persona chat...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="persona-chat-page">
        <div className="error-container">
          <h2>❌ Error</h2>
          <p>{error}</p>
          <button onClick={() => window.location.href = '/'}>
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  if (!persona) {
    return (
      <div className="persona-chat-page">
        <div className="error-container">
          <h2>Persona Not Found</h2>
          <p>The persona you're looking for doesn't exist.</p>
          <button onClick={() => window.location.href = '/'}>
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="persona-chat-page">
      <PersonaLiveKitChat 
        personaId={personaId} 
        personaName={persona.name}
      />
    </div>
  );
};

export default PersonaChatPage;
